var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 28,
    viewBox: "0 0 21 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H19.3824V26L10.0036 19.9484L1 26V1Z",
    stroke: "url(#paint0_linear_5804_3543)",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5804_3543",
    x1: 10.1912,
    y1: 1,
    x2: 10.1912,
    y2: 26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0EC71E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9437FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveOutline);
export default __webpack_public_path__ + "static/media/save-outline.b60e8d23ddc4ab269aee588de96cd3f3.svg";
export { ForwardRef as ReactComponent };